import { render, staticRenderFns } from "./Igaming.vue?vue&type=template&id=907783e0"
import script from "./Igaming.vue?vue&type=script&lang=js"
export * from "./Igaming.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports